/* eslint-disable operator-linebreak */
import { createAction } from '@reduxjs/toolkit';
import { IDownloadDocumentRequest,
	IDocumentDownloadPDF,
	IDownloadCsvRequest,
	IDocumentDownloadCSV }
	from "app/interfaces/document-download/document-download.interface";

// export const GET_FUNDING_VALIDATION = 'GET_FUNDING_VALIDATION';
export const SUBMIT_FUNDING = 'SUBMIT_FUNDING';
export const SUBMIT_BULK_FUNDING = 'SUBMIT_BULK_FUNDING';
export const GENERATE_PRIVY_FUNDING = 'GENERATE_PRIVY_FUNDING';
export const SUCCESS_FUNDING = 'SUCCESS_FUNDING';
export const FAILED_FUNDING = 'FAILED_FUNDING';
export const RESET_FUNDING_STATE = 'RESET_FUNDING_STATE';
export const GET_LOAN_AGREEMENT = 'GET_LOAN_AGREEMENT';
export const SET_LOAN_AGREEMENT = 'SET_LOAN_AGREEMENT';
export const RESET_LOAN_AGREEMENT = 'RESET_LOAN_AGREEMENT';
export const DOWNLOAD_AGREEMENT_PDF = "DOWNLOAD_AGREEMENT_PDF";
export const DOWNLOAD_LENDER_AGREEMENT_PDF = "DOWNLOAD_LENDER_AGREEMENT_PDF";
export const DOWNLOAD_TRANSACTION_HISTORY_CSV = "DOWNLOAD_TRANSACTION_HISTORY_CSV";
export const SET_AGREEMENT_PDF = "SET_AGREEMENT_PDF";
export const SET_LENDER_AGREEMENT_PDF = "SET_LENDER_AGREEMENT_PDF";
export const SET_TRANSACTION_HISTORY_CSV = "SET_TRANSACTION_HISTORY_CSV";
export const RESET_AGREEMENT_PDF = "RESET_AGREEMENT_PDF";
export const RESET_TRANSACTION_HISTORY_CSV = "RESET_TRANSACTION_HISTORY_CSV";
export const SET_AGREEMENT_ERROR = 'SET_AGREEMENT_ERROR';
export const SUCCESS_BULK_FUNDING = 'SUCCESS_BULK_FUNDING';

export interface ISubmitFundingPayload {
	loanId: string;
	amount: number;
	loanNumber: string;
}

export interface ISubmitBulkFundingPayload {
	loan_type_secure_id: string;
	loan_bulk_upload_group_id: string;
}

export interface IPrivyFundingResponse {
	docToken: string;
	signCoordinatePage: number;
	digiSignId: string;
}

export interface IFailedFundingResponse {
	error: string;
}

export interface IAgreementDocumentRequest {
	loanNumber: string;
	lenderUserId: string;
	amount: number;
}

export interface IAgreementDocumentResponse {
	PPFP_filepath: string;
	PP_filepath: string;
}

export interface IBulkLoanNumberRequest {
	bulk_secure_id: string;
}

export interface IBulkLoanNumberResponse {
	loan_number: string;
	amount: number;
}

// export const getFundingValidationAction =
//     createAction<IMarketplaceListRequest>(GET_FUNDING_VALIDATION);
export const submitFundingAction =
	createAction<ISubmitFundingPayload>(
		SUBMIT_FUNDING
	);
export const submitBulkFundingAction =
	createAction<ISubmitBulkFundingPayload>(
		SUBMIT_BULK_FUNDING
	);
export const generatePrivyFundingAction =
	createAction<IPrivyFundingResponse>(
		GENERATE_PRIVY_FUNDING
	);
export const successFundingAction =
	createAction<ISubmitFundingPayload>(
		SUCCESS_FUNDING
	);
export const failedFundingAction =
	createAction<IFailedFundingResponse>(
		FAILED_FUNDING
	);
export const resetFundingStateAction =
	createAction<boolean>(
		RESET_FUNDING_STATE
	);
export const getLoanAgreementDocumentAction =
    createAction<IAgreementDocumentRequest>(
		GET_LOAN_AGREEMENT
	);
export const setLoanAgreementDocumentAction =
    createAction<IAgreementDocumentResponse>(
		SET_LOAN_AGREEMENT
	);
export const resetLoanAgreementDocumentAction =
    createAction(
		RESET_LOAN_AGREEMENT
	);
export const downloadAgrementPDFAction =
	createAction<IDownloadDocumentRequest>(
		DOWNLOAD_AGREEMENT_PDF
	);
export const downloadLenderAgrementPDFAction =
	createAction<IDownloadDocumentRequest>(
		DOWNLOAD_LENDER_AGREEMENT_PDF
	);
export const downloadTransactionHistoryCsvAction =
	createAction<IDownloadCsvRequest>(
		DOWNLOAD_TRANSACTION_HISTORY_CSV
	);
export const setAgreementPDFAction =
	createAction<IDocumentDownloadPDF>(
		SET_AGREEMENT_PDF
	);
export const setLenderAgreementPDFAction =
	createAction<IDocumentDownloadPDF>(
		SET_LENDER_AGREEMENT_PDF
	);
export const setTransactionHistoryCsvAction =
	createAction<IDocumentDownloadCSV>(
		SET_TRANSACTION_HISTORY_CSV
	);
export const resetAgreementPDFAction =
	createAction(
		RESET_AGREEMENT_PDF
	);
export const resetTransactionHistoryCsvAction =
	createAction(
		RESET_TRANSACTION_HISTORY_CSV
	);
export const setErrorAgreement =
	createAction<string>(
		SET_AGREEMENT_ERROR
	);
export const successBulkFundingAction =
	createAction<boolean>(
		SUCCESS_BULK_FUNDING
	);
